export const categoryList = [
  {
    type: "movie",
    label: "电影",
    icon: "ri-film-line",
    tagline: "光影巨制 · 大银幕故事",
    intro:
      "汇聚科幻、古装、动作、剧情等多元电影类型，从院线热映到口碑佳作，为影迷提供完整的观影指南与详情浏览。",
    image:
      "https://readdy.ai/api/search-image?query=a%20glowing%20vintage%20film%20projector%20casting%20warm%20light%20in%20a%20dark%20cinema%20hall%2C%20rows%20of%20red%20seats%2C%20cinematic%20atmosphere%2C%20moody%20lighting%2C%20highly%20detailed%20photography&width=800&height=600&seq=cnfilm-cat-movie&orientation=landscape",
  },
  {
    type: "tv",
    label: "电视剧",
    icon: "ri-tv-2-line",
    tagline: "追剧不停 · 长线故事",
    intro:
      "覆盖古装权谋、都市情感、悬疑刑侦、科幻太空等热门剧集，支持按年代与题材浏览，追剧选剧一目了然。",
    image:
      "https://readdy.ai/api/search-image?query=a%20cozy%20living%20room%20with%20a%20large%20television%20screen%20glowing%20at%20night%2C%20warm%20ambient%20lamp%20light%2C%20comfortable%20sofa%2C%20cinematic%20atmosphere%2C%20moody%20lighting%2C%20highly%20detailed%20photography&width=800&height=600&seq=cnfilm-cat-tv&orientation=landscape",
  },
  {
    type: "variety",
    label: "综艺",
    icon: "ri-mic-2-line",
    tagline: "轻松解压 · 真人秀现场",
    intro:
      "真人秀、音乐竞演、美食纪录、脱口秀等综艺内容一站聚合，节奏轻快，随时随地享受欢乐时光。",
    image:
      "https://readdy.ai/api/search-image?query=a%20colorful%20bright%20variety%20show%20stage%20with%20stage%20lights%20and%20confetti%2C%20energetic%20festive%20atmosphere%2C%20cinematic%20atmosphere%2C%20vibrant%20lighting%2C%20highly%20detailed%20photography&width=800&height=600&seq=cnfilm-cat-variety&orientation=landscape",
  },
];

export const categoryMeta: Record<string, { label: string; intro: string }> = {
  movie: {
    label: "电影",
    intro: "电影频道收录科幻、古装、动作、剧情等多元类型影片，汇聚院线热映与口碑佳作。",
  },
  tv: {
    label: "电视剧",
    intro: "电视剧频道覆盖古装权谋、都市情感、悬疑刑侦、科幻太空等热门剧集。",
  },
  variety: {
    label: "综艺",
    intro: "综艺频道聚合真人秀、音乐竞演、美食纪录、脱口秀等轻松内容。",
  },
};